/* eslint-disable */

/** unique or primary key constraints on table "argo.connection" */
export enum ArgoConnectionConstraint {
  /** unique or primary key constraint on columns "connection_id" */
  ArgoConnectionPkey = 'argo_connection_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  ArgoConnectionUniqueName = 'argo_connection_unique_name'
}

/** select columns of table "argo.connection" */
export enum ArgoConnectionSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.connection" */
export enum ArgoConnectionUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

